import * as React from 'react'
function SvgSkull(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 4C12.2 4 6 10.2 6 18c0 4.8 2.4 9 6 11.4V34c0 1.2.8 2 2 2h2v-4h2v4h4v-4h2v4h2c1.2 0 2-.8 2-2v-4.6c3.6-2.6 6-6.8 6-11.4 0-7.8-6.2-14-14-14zm-5 18c-1.6 0-3-1.4-3-3s1.4-3 3-3 3 1.4 3 3-1.4 3-3 3zm10 0c-1.6 0-3-1.4-3-3s1.4-3 3-3 3 1.4 3 3-1.4 3-3 3z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgSkull
